import React from 'react';
import { mission } from '../../content/site';

import bg from '../../images/mission.jpg';

const OurMission = () => (
  <section className="section section--dark mission" id="mission">
    <div className="mission__bg" aria-hidden="true">
      <img src={bg} alt="" loading="lazy" decoding="async" />
    </div>

    <div className="container">
      <div className="section-head">
        <p className="eyebrow">{mission.eyebrow}</p>
        <h2>Why we build, and what we are building towards.</h2>
      </div>

      <div className="mission__grid">
        <div className="mission__block reveal">
          <h3 className="mission__title">{mission.statement.title}</h3>
          <p className="mission__body">{mission.statement.body}</p>
        </div>

        <div className="mission__block reveal" style={{ '--reveal-delay': '110ms' }}>
          <h3 className="mission__title">{mission.vision.title}</h3>
          <p className="mission__body">{mission.vision.body}</p>
        </div>
      </div>
    </div>
  </section>
);

export default OurMission;
